/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TopScorer = {
    properties: {
        topScorer1: {
            type: 'any-of',
            contains: [{
                type: 'PlayerListElement',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        topScorer1Goals: {
            type: 'number',
            isRequired: true,
        },
        topScorer2: {
            type: 'any-of',
            contains: [{
                type: 'PlayerListElement',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        topScorer2Goals: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
